import i18next from 'i18next';
import { generateRandomString } from '../../../utils';

import fileToBase64 from './fileToBase64';
import SelectedFile from '../entity/SelectedFile';
import { resolveReadableFileSize } from './resolveReadableFileSize';
import constants from '../config/constants';
import TransferImportFile from '../entity/TransferImportFile';

const getT = () => i18next.getFixedT(null, 'DropZone');

export const resolveErrorData = (file, maxFileSizeMB, allowedMimeTypes) => {
    const t = getT();

    if (file.size > maxFileSizeMB * constants.bytesInMegabyte) {
        const tooBigNotification = `${t('theme.dropzone.too_big_file')}.`;
        const maxSizeNotification = `${
            t('theme.dropzone.max-file-size', { maxFileSize: `${maxFileSizeMB} MB` })
        }.`;

        return [tooBigNotification, maxSizeNotification].join(' ');
    }

    if (allowedMimeTypes && !allowedMimeTypes.includes(file.type)) {
        return `${t('theme.dropzone.not_allowed_file_mime_type')}.`;
    }

    return null;
};

export const normalizeFile = async (
    file,
    maxFileSizeMB,
    contentBase64Encoded = true,
    allowedMimeTypes = null,
) => new SelectedFile(
    generateRandomString(),
    resolveReadableFileSize(file.size),
    new TransferImportFile(
        file.name,
        file.type,
        contentBase64Encoded ? await fileToBase64(file) : file,
    ),
    resolveErrorData(file, maxFileSizeMB, allowedMimeTypes),
);
